module.exports = __webpack_public_path__ + "img/GP.fa2d39cf.svg";